import { useCallback, useEffect, useRef, useState } from "react";

/**
 * 统一处理剪贴板写入和短时成功反馈，并在组件卸载或重复复制时清理计时器。
 * 浏览器拒绝剪贴板权限时不会抛出未处理异常，调用方仍可保留原值供用户手动复制。
 */
export function useCopyFeedback(value: string, feedbackDuration = 1_200) {
  const [copied, setCopied] = useState(false);
  const resetTimer = useRef<number | undefined>(undefined);

  useEffect(() => () => {
    if (resetTimer.current !== undefined) window.clearTimeout(resetTimer.current);
  }, []);

  const copy = useCallback(async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      if (resetTimer.current !== undefined) window.clearTimeout(resetTimer.current);
      resetTimer.current = window.setTimeout(() => { setCopied(false); }, feedbackDuration);
    } catch {
      setCopied(false);
    }
  }, [feedbackDuration, value]);

  return { copied, copy } as const;
}
